import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import DateTr from "../table-componets/DateTr.js";
import GeneralTr from "../table-componets/GeneralTr.js";
import LinkTr from "../table-componets/LinkTr.js";
import GeneralTd from "../table-componets/GeneralTd.js";
import PhoneNumberTd from '../table-componets/PhoneNumberTd.js'
import LinkTd from "../table-componets/LinkTd.js";
import Instructors from "./Instructors.js";

class GroupLesson extends React.Component {
  state = {
    members: this.props.groupLesson.group_lesson_members,
    currentUserAdmin: this.props.currentUser.admin
  };

  deleteGroupLesson = () => {
    if (window.confirm("Are you sure you want to delete this lesson?")) {
      axios
        .delete("/group_lessons/" + this.props.groupLesson.id)
        .then(function(response) {
          toastr.error("Lesson deleted");
          setTimeout(
            function() {
              window.location.href = "/group_lessons";
            }.bind(this),
            300
          );
        })
        .catch(function(error) {
          toastr.error("An error occured, please try again.");
          console.log(error);
        });
    }
  };

  duplicateGroupLesson = (event) => {
    if (!window.confirm("Are you sure you want to duplicate this lesson?")) {
      event.preventDefault();
    }
  };

  componentDidMount() {
    var that = this;

    $("#members").kendoAutoComplete({
      dataTextField: "ProductName",
      filter: "contains",
      minLength: 1,
      template:
        "<dl>" +
        "<dt>${ data.first_name } ${ data.last_name }</dt>" +
        "<dd>${ data.age } ${ (data.gender === 'M' || data.gender === 'F') ? data.gender : '' }</dd>" +
        "</dl>",
      dataSource: {
        serverFiltering: true,
        transport: {
          read: {
            url: "/members.json?method=age"
          },
          parameterMap: function(op) {
            return { search: op.filter.filters[0].value };
          }
        }
      },
      select: function(e) {
        var dataItem = this.dataItem(e.item.index());
        var members = that.state.members;

        axios
          .post("/group_lesson_members", {
            group_lesson_member: {
              group_lesson_id: that.props.groupLesson.id,
              member_id: dataItem.id
            }
          })
          .then(function(response) {
            toastr.success("Member added to lesson");
            members.push(response.data);
            that.setState({ members: members });
          })
          .catch(function(error) {
            toastr.error("Member not added");
            console.log(error);
          });
      },
      change: function(e) {
        $("#members")
          .data("kendoAutoComplete")
          .value("");
      }
    });
  }

  deleteMember = groupLessonMemberId => {
    var that = this;

    if (
      confirm(
        "Are you sure you want to remove this member from the lesson?"
      ) == true
    ) {
      var members = _.reject(this.state.members, { id: groupLessonMemberId });

      axios
        .delete("/group_lesson_members/" + groupLessonMemberId)
        .then(function(response) {
          toastr.error("Lesson Member deleted");
          that.setState({ members: members });
        })
        .catch(function(error) {
          toastr.error("An error occured, please try again later");
          console.log(error);
        });
    }
  };

  isGroupLessonInstrcutor(groupLesson){
    for(var instructor of groupLesson.group_lesson_instructors){
      if(instructor.user.id === this.props.currentUser.id){
        return true;
      } 
    }
    return false;
  }

  renderMembersBody() {
    var that = this;

    var members = this.state.members.map((glm, index) => {
      return (
        <tr key={index}>
          <LinkTd
            fieldName={glm.member.last_name}
            fieldURL={"/members/" + glm.member.id}
          />
          <LinkTd
            fieldName={glm.member.first_name}
            fieldURL={"/members/" + glm.member.id}
          />
          <PhoneNumberTd fieldValue={glm.member.formatted_phone_number} />
          <GeneralTd fieldValue={glm.member.age} />
          <GeneralTd fieldValue={glm.member.gender === 'M' || glm.member.gender === 'F' ? glm.member.gender : ''} />
          <td>
            <a
              className="btn btn-text pull-right"
              tabIndex="0"
              onClick={function() {
                that.deleteMember(glm.id);
              }}
              onKeyDown={(e)=>{
                if(e.key === 'Enter'){
                  that.deleteMember(glm.id)
                }
              }}
            >
              DELETE
            </a>
          </td>
        </tr>
      );
    });

    return <tbody>{members}</tbody>;
  }

  render() {
    var that = this;

    return (
      <div>
        <h1>Lesson</h1>
        <br className="visible-xs" />
        <br className="visible-xs" />

        <div className="pull-right">
          {(that.state.currentUserAdmin ||
            (that.props.currentUser.id == that.props.groupLesson.coordinator_id) ||
            that.isGroupLessonInstrcutor(that.props.groupLesson)) && (
            <span>
              <a
                href={"/group_lessons/" + that.props.groupLesson.id + "/edit"}
                className="btn btn-pink btn-raised btn-long margin-right-five"
              >
                EDIT
              </a>

              {that.state.members.length ? (
                <a
                  href={
                    "/report_cards?group_lesson_id=" +
                    that.props.groupLesson.id
                  }
                  className="btn btn-indigo btn-raised btn-long margin-right-five width-auto"
                >
                  {this.props.groupLesson.group_lesson_program.report_card_language_pluralized.toUpperCase()}
                </a>
              ) : (
                <a className="btn btn-indigo btn-raised btn-long disabled margin-right-five width-auto">
                  {this.props.groupLesson.group_lesson_program.report_card_language_pluralized.toUpperCase()}
                </a>
              )}

              {that.state.currentUserAdmin && (
                <span className="dropdown">
                  <button
                    id="options"
                    type="button"
                    className="btn btn-default btn-raised btn-long dropdown-toggle hidden-xs hidden-sm"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    OPTIONS
                    <span className="caret" />
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="options">
                    <li>
                      <a
                        className="pointer-hand"
                        onClick={function(event) {
                          that.duplicateGroupLesson(event);
                        }}
                        href={`/group_lessons/${that.props.groupLesson.id}/duplicate`}
                      >
                        DUPLICATE
                      </a>
                    </li>
                    <li>
                      <a
                        className="pointer-hand"
                        tabIndex="0"
                        onClick={function() {
                          that.deleteGroupLesson();
                        }}

                        onKeyDown={(e)=>{
                          if(e.key === 'Enter'){
                            that.deleteGroupLesson();
                          }
                        }}
                      >
                        DELETE
                      </a>
                    </li>
                  </ul>
                </span>
              )}
            </span>
          )}
        </div>
        <br />
        <br />
        <h4>Basic Information</h4>
        <div className="shadowDepth1">
          <table className="table table-bordered table-white">
            <tbody>
              <GeneralTr
                fieldName={"Location"}
                fieldValue={that.props.groupLesson.location.name}
              />
              <GeneralTr
                fieldName={"Program"}
                fieldValue={that.props.groupLesson.group_lesson_program.name}
              />
              <GeneralTr
                fieldName={"Level"}
                fieldValue={that.props.groupLesson.group_lesson_level.name}
              />

              {this.props.groupLesson.group_lesson_instructors != 0 ? (
                <Instructors
                  fieldName="Instructor(s)"
                  instructors={this.props.groupLesson.group_lesson_instructors}
                  instructorsLength={this.props.groupLesson.group_lesson_instructors.length}
                />
              ) : (
                <GeneralTr
                  fieldName={"Instructor"}
                  fieldValue={"No instructor assigned"}
                />
              )}

              {this.props.groupLesson.coordinator_id &&
              this.props.groupLesson.coordinator ? (
                <LinkTr
                  fieldName="Coordinator"
                  fieldValue={
                    that.props.groupLesson.coordinator.last_name +
                    ", " +
                    that.props.groupLesson.coordinator.first_name
                  }
                  fieldURL={"/users/" + that.props.groupLesson.coordinator_id}
                />
              ) : (
                <GeneralTr
                  fieldName={"Coordinator"}
                  fieldValue={"No coordinator assigned"}
                />
              )}

              <GeneralTr
                fieldName={"Session"}
                fieldValue={that.props.groupLesson.session_schedule}
              />
              <GeneralTr
                fieldName={"Class Code"}
                fieldValue={that.props.groupLesson.class_code}
              />
              <GeneralTr
                fieldName={"Notes"}
                fieldValue={that.props.groupLesson.notes}
              />
            </tbody>
          </table>
        </div>
        <br />
        <h4>Members</h4>
        {that.state.members.length ? (
          <div>
            <table className="table table-clean table-white shadowDepth1">
              <thead>
                <tr>
                  <th>Last Name</th>
                  <th>First Name</th>
                  <th>Phone Number</th>
                  <th>Age</th>
                  <th>Gender</th>
                  <th />
                </tr>
              </thead>
              {that.renderMembersBody()}
            </table>
            <br />
          </div>
        ) : (
          <span />
        )}
        <div className="shadowDepth1">
          <input
            id="members"
            className="full-width"
            placeholder="To add a member, search by first or last name"
          />
        </div>
        <br />
        <br />
      </div>
    );
  }
}

GroupLesson.propTypes = {
  groupLesson: PropTypes.object,
  groupLessonMembers: PropTypes.object,
  currentUser: PropTypes.object
};

export default GroupLesson;
